module.exports = __webpack_public_path__ + "static/media/handle2.ae625112.png";